// extracted by mini-css-extract-plugin
module.exports = {"drawer-footer":"QuestionDrawer_style_drawer-footer__2Pijg"};